import { Container, makeStyles, Typography } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import Chatbot from 'react-chatbot-kit';

import RoboIcon from '../components/chatbot/RoboIcon/RoboIcon';
import { LanguageContext } from '../Language/LanguageProvider';
import AnimatedBackground from '../ui/AnimatedBackground';
import usePageStyle from './usePageStyle';
import config from '../components/chatbot/config';
import ActionProvider from '../components/chatbot/ActionProvider';
import MessageParser from '../components/chatbot/MessageParser';
import '../components/chatbot/chatbot.css';

const useStyle = makeStyles(theme => ({
  container: {
    padding: 0,
    paddingTop: '1.5em',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0.5em',
    },
  },
  title: {
    ...theme.typography.mainText,
    textAlign: 'center',
    fontSize: '2rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  paragraph: {
    marginTop: '1em',
    textAlign: 'center',
    fontSize: '2.5rem',
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
}));

const Home = () => {
  const [showChat, setShowChat] = useState(false);

  const classes = usePageStyle();
  const localClasses = useStyle();
  const { dictionary } = useContext(LanguageContext);
  return (
    <>
      <AnimatedBackground />
      <main className={classes.page}>
        <Container className={localClasses.container} maxWidth="xl">
          <Typography className={localClasses.title} component="div">
            {dictionary['home-title']}
          </Typography>
          <Typography
            className={localClasses.paragraph}
            component="div"
            variant="subtitle1"
          >
            {dictionary['home-text']}
          </Typography>
        </Container>
        {showChat && (
          <div className="ChatBot-container">
            <Chatbot
              config={config}
              actionProvider={ActionProvider}
              messageParser={MessageParser}
            />
          </div>
        )}
        <RoboIcon
          handleOpenChat={setShowChat}
          isChatOpen={showChat}
          color={showChat ? '#0278ae' : 'white'}
        />
      </main>
    </>
  );
};

export default Home;
